import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const projectServiceOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: true,
    expandRowKeys: [],
    rowKey: 'id',
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '220',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "工程单编号",
            prop: "workOrderNum",
            type: 'input',
            search: true,
        },
        {
            label: "预约人姓名",
            prop: "reservationName",
            search: true,
            type: 'input',
        },
        {
            label: "预约人电话",
            prop: "reservationMobile",
            search: true,
            type: 'input',
        },

        {
            label: "工程项目名称",
            prop: "serviceCategoryName",
            type: 'input',
        },
        {
            label: "工程师姓名",
            prop: "workUserName",
            search: true,
            hide: true,
            type: 'input',
        },
        {
            label: "工程服务时间",
            prop: "serviceTime",
            type: "datetime",
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            // sortable: true,
            // formatter: function (row, value, label, column) {
            //     let time = row.time + parseStatus(DIC.SERVICE_WARRANTY_DATE_TYPE, row.type)
            //     return time
            // },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "服务地址",
            prop: "address",
            search: true,
            type: 'input',
        },
        {
            label: "总服务费",
            prop: "totalMoney",
            type: 'input',
            formatter: function (row) {
                if (row.totalMoney == 0) {
                    return '-'
                } else {
                    return row.totalMoney
                }
            }
        },
        {
            label: "预约渠道",
            prop: "reservationChannel",
            search: true,
            type: 'select',
            dicData: DIC.SERVICEITEM_TYPE
        },
        {
            label: "工程单状态",
            prop: "status",
            search: true,
            type: 'select',
            dicData: DIC.WORK_PROJECT_SERVICE
        },
        {
            label: "创建人",
            prop: "createBy",
            type: 'input',
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "工程服务时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};